import '@fortawesome/fontawesome-svg-core/styles.css';
import { library, config } from '@fortawesome/fontawesome-svg-core'

import {
  faGithub,
  faDribbble,
  faTwitter,
  faFacebook,
  faReddit,
  faJs,
  faHtml5,
  faCss3,
  faCodepen,
  faReact,
  faNode,
} from '@fortawesome/free-brands-svg-icons'
import {
  faPaintBrush,
  faCode,
  faWindowMaximize,
  faHandshake,
  faPaperPlane,
  faChevronRight,
  faChevronLeft,
  faClock,
  faCalendarAlt,
  faBars,
  faTimes,
  faMoon,
  faSun,
  faEdit
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faGithub,
  faDribbble,
  faTwitter,
  faFacebook,
  faReddit,
  faPaintBrush,
  faWindowMaximize,
  faCode,
  faJs,
  faHandshake,
  faPaperPlane,
  faHtml5,
  faCss3,
  faCodepen,
  faChevronRight,
  faChevronLeft,
  faClock,
  faCalendarAlt,
  faReact,
  faNode,
  faBars,
  faTimes,
  faMoon,
  faSun,
  faEdit
);
config.autoAddCss = false;

